import {
  Text,
} from "@chakra-ui/react";
import Aos from "aos";
import React from "react";
import { useEffect } from "react";
import masaialumni from "./ProjectImages/masai_alumni.png"
import jio_home from "./ProjectImages/jio_home.png"
import tripoto2 from "./ProjectImages/booking.png";
import todoapp from "./ProjectImages/todoapp.png";
import ProjectCard from "./ProjectCard";
import GitStats from "../GitStats";
import wechat from "./ProjectImages/wechatapp.png"

const Projects = ({ id }) => {
  useEffect(() => {
    Aos.init();
  }, []);

  const projectData = [
    
    {
      imageSrc: masaialumni,
      title: "Masai Alumni",
      description: "Masai Alumni is a live project designed for Masai School alumni who have completed the courses and successfully secured jobs.",
      techStack: "Mongodb | Express.js| Redux | Typescript | Chakra UI | React | Node.js | Jwt | Socket.io",
      role: "It was group project executed in 2 months",
      deployedLink:"https://masai-alumni-temp.onrender.com/",
      githubLink: "https://github.com/YelveTejas/masai-alumni-temp",
    },
    {
      imageSrc: wechat,
      title: "Wechat",
      description: "The real-time chat application has been developed with user-friendly features, enabling seamless one-on-one conversations and group discussions. Notably, a group chat functionality is in place, exclusively administered by designated personnel with the authority to manage users. Additionally, a typing indicator and notifications has been implemented to provide real-time feedback during conversations.",
      techStack: "Socket.io |Mongodb | Express.js| Redux |  Chakra UI | React | Node.js | Jwt ",
      role: "It was individual project executed in 2 weeks",
      deployedLink:"https://chatspehre.netlify.app/",
      githubLink: "https://github.com/YelveTejas/wechat",
    },
    {
      imageSrc: todoapp,
      title: "Todo App",
      description: "  Full stack todo app where you can add, delete, update your todos.",
      techStack: "Mongodb | MUI | React | Node.js | Express.js | Redux | Middleware",
      role: "It was an individual Project.",
      deployedLink: "https://sparkly-sherbet-8b2367.netlify.app/",
      githubLink: "https://github.com/YelveTejas/Todo-frontend",
    },
    {
      imageSrc:tripoto2,
      title: "Tripoto",
      description: " Tripoto is a global community of travellers. It is the world's largest UGC- (user-generated content) based search portal everything associated with travelling with a unique user base of 25 million+ people in the community. Tripoto is collectively visited by 2.5 million unique users every month to read content generated by fellow real travellers.",
      techStack: "React | React-Router-Dom | Axios | Json-Server | Dynamic Routing",
      role: "It was an individual Project.",
      deployedLink: "https://fabulous-cobbler-459f32.netlify.app/",
      githubLink: "https://github.com/YelveTejas/wasteful-underwear-8541",
    },
    {
      imageSrc:jio_home,
      title: "Jio Mart",
      description: "JioMart is an Indian e-commerce company, headquartered in NaviMumbai, Maharashtra.",
      techStack: " React | Redux| ChakraUI | Mongoose | Express | Nodejs",
      role: " It was group project.Executated Authentication through backend.Built signup,signin and cart page",
      deployedLink: "https://jolly-choux-78cc48.netlify.app/",
      githubLink: "https://github.com/vishnu9651/rampant-rabbit-487",
    },
    // Add
    // Add as many projects as needed
  ];

  return (
    <div name="project" id={id}>
      <Text
        mt={20}
        fontSize="2rem"
        fontWeight="medium"
        color="orange.500"
        textAlign="center"
      >
        MY PROJECTS
      </Text>
       {projectData.map((project, index) => (
        <ProjectCard key={index} {...project} />
      ))}
    <GitStats/>
    </div>
  );
};

export default Projects;
